<nav class="navbar">
  <div class="navbar-left">
    <img class="img-logo" alt="logo" src="/assets/img/seve_Logo_nav_White.png" />

    <mat-form-field appearance="fill" class="user-select">
      <mat-select panelClass="user-role-panel" [(ngModel)]="selectedRole" (selectionChange)="onProfileSelected(selectedRole)" [compareWith]="compareRoles">
        <mat-select-trigger>
          <div class="user-trigger">
            <span class="user-name">{{ user?.userFirstName }} {{ user?.userName }}</span>
            <span class="role-info" *ngIf="selectedRole">
              {{ selectedRole?.profileCode === 'ACD' ? selectedRole?.perimeterName : selectedRole?.profileCode + '_' + selectedRole?.perimeterName }}
            </span>
          </div>
        </mat-select-trigger>
        <mat-option *ngFor="let r of user?.roles" [value]="r">
          <ng-container *ngIf="r?.profileCode != 'ACD'"> {{ r?.profileCode }}_{{ r?.perimeterName }} </ng-container>
          <ng-container *ngIf="r?.profileCode == 'ACD'">
            {{ r?.perimeterName }}
          </ng-container>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-icon [matMenuTriggerFor]="menuSettings" class="settings-icon">settings</mat-icon>
    <mat-menu #menuSettings="matMenu" xPosition="after">
      <a [routerLink]="SiteMapUrl.MenuAccount" mat-menu-item> <mat-icon>account_circle</mat-icon>{{ 'nav_my_account' | translate }} </a>
      <mat-divider></mat-divider>
      <a (click)="logout()" mat-menu-item> <mat-icon>logout</mat-icon>{{ 'nav_logout' | translate }} </a>
    </mat-menu>
  </div>

  <div class="navbar-right">
    <mat-form-field *ngIf="showLanguageSelector" appearance="fill" class="navbar-select">
      <mat-select [(ngModel)]="selectedLanguage" (selectionChange)="onLanguageChange($event.value)" [placeholder]="'nav_language_placeholder' | translate">
        <mat-select-trigger>{{ 'nav_language_' + selectedLanguage | translate }}</mat-select-trigger>
        <mat-option value="fr">{{ 'nav_language_french' | translate }}</mat-option>
        <mat-option value="en">{{ 'nav_language_english' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="showDatabaseSelector" appearance="fill" class="navbar-select">
      <mat-select [(ngModel)]="selectedDatabase" (selectionChange)="onDatabaseChange($event.value)" [placeholder]="'nav_database_placeholder' | translate">
        <mat-select-trigger>{{ selectedDatabaseTranslationKey | translate }}</mat-select-trigger>
        <mat-option value="1">{{ 'nav_database_FR' | translate }}</mat-option>
        <mat-option value="2">{{ 'nav_database_ES' | translate }}</mat-option>
        <mat-option value="3">{{ 'nav_database_CA_EN' | translate }}</mat-option>
        <mat-option value="4">{{ 'nav_database_CA_FR' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <span *ngIf="showUsefulDocs" class="navbar-link navbar-dropdown-trigger" [matMenuTriggerFor]="menuDocuments">{{ 'nav_useful_documents' | translate }} ▾</span>
    <mat-menu #menuDocuments="matMenu">
      <a href="https://seve-tp.com/#informations" target="_blank" mat-menu-item>{{ 'nav_useful_documents_link' | translate }}</a>
      <a href="https://www.youtube.com/watch?v=wJIVjenQSoM" target="_blank" mat-menu-item>{{ 'nav_video_tuto' | translate }}</a>
      <a href="https://tpdemain.com/formation/reduire-empreinte-seve/" target="_blank" mat-menu-item>{{ 'nav_tp_demain' | translate }}</a>
    </mat-menu>
    <a *ngIf="showHelp" [routerLink]="SiteMapUrl.MenuHelp" class="navbar-link">{{ 'nav_help' | translate }}</a>
  </div>
</nav>
